<mat-form-field appearance="outline" class="custom-mat-form-field !rounded-2xl !w-[100%]">
  <mat-label>Country</mat-label>
  <mat-select
    [formControl]="countryControl"
    [(value)]="selectedCountry"
    placeholder="Select Country"
    style="font-size: 14px !important"
    (selectionChange)="onCountrySelect($event.value)"
    class="mat-form-field"
  >
    <mat-select-trigger>
      <div class="flex items-center" *ngIf="selectedCountry">
        <img
          [src]="selectedCountry?.flag"
          alt="Flag"
          width="24"
          height="16"
          class="mr-2"
        />
        {{ selectedCountry?.name }}
      </div>
    </mat-select-trigger>
    <input
      matInput
      type="text"
      placeholder="Search for a country..."
      [formControl]="searchTermControl"
      (input)="filteredCountries"
      class="search-input sticky top-0 z-50"
    />
    <mat-option *ngFor="let country of filteredCountries" [value]="country" class="border-b isActive">
      <div class="flex items-center  ">
        <img
          [src]="country?.flag"
          alt="{{ country?.name }} Flag"
          width="24"
          height="16"
          class="mr-2"
        />
        {{ country?.name }}
      </div>
    </mat-option>
  </mat-select>
  <mat-error *ngIf="countryControl.hasError('required')">
    Select a country
  </mat-error>
</mat-form-field>
